'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'files';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e178';
var svgPathData = 'M128 384l0-352 176 0 0 96 0 16 16 0 96 0 0 240-288 0zM336 57.5L390 112l-54 0 0-54.5zM324 0L128 0 96 0l0 32 0 352 0 32 32 0 288 0 32 0 0-32 0-259L324 0zM32 112l0-16L0 96l0 16L0 496l0 16 16 0 320 0 16 0 0-32-16 0L32 480l0-368z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFiles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;